<template>
  <div class="ws-state-content-block">
    <WsCard v-if="type=='infoCard'">
      <div
        v-for="(floor,floorKey) in floors"
        :key="floorKey"
        class="ws-content"
      >
        <WsContentTitle v-if="floor.title" class="mb-2">{{floor.title}}</WsContentTitle>
        <WsContentRemark v-if="floor.remark" class="mb-2">{{floor.remark}}</WsContentRemark>
        <div>
          <WsState
            v-for="(fieldKey,fieldIndex) in floor.fields"
            :key="fieldIndex"
            :label="$_CMS_getLabelByHideLabelFields(fieldKey,modedFields,floor.hideLabelFields)"
            :type="$_getFieldAttr(fieldKey,'type')"
            :fields="$_getFieldAttr(fieldKey,'fields')"
            :textKey="$_getFieldAttr(fieldKey,'textKey')"
            :valueKey="$_getFieldAttr(fieldKey,'valueKey')"
            :getText="$_getFieldAttr(fieldKey,'getText')"
            :getValue="$_getFieldAttr(fieldKey,'getValue')"
            :modelName="$_getFieldAttr(fieldKey,'modelName')"
            :placeholder="$_getFieldAttr(fieldKey,'placeholder')"
            :parent="$_getFieldAttr(fieldKey,'parentKey')"
            :requiredField="$_getFieldAttr(fieldKey,'requiredField')"
            :uploadUrl="$_getFieldAttr(fieldKey,'uploadUrl')"
            :items="$_getFieldAttr(fieldKey,'items')"
            :displayLabel="$_getFieldAttr(fieldKey,'displayLabel')"
            :rules="$_getFieldAttr(fieldKey,'rules')"
            :activeText="$_getFieldAttr(fieldKey,'activeText')"
            :inactiveText="$_getFieldAttr(fieldKey,'inactiveText')"
            :orderWay="$_getFieldAttr(fieldKey,'orderWay')"
            :orderBy="$_getFieldAttr(fieldKey,'orderBy')"
            :noReset="$_getFieldAttr(fieldKey,'noReset')"
            :hasCloseChips="$_getFieldAttr(fieldKey,'hasCloseChips')"
            :verifyApi="$_getFieldAttr(fieldKey,'verifyApi')"
            :conditions="$_getConditions(fieldKey)"
            :parentState="$_getParentState(fieldKey,modedFields)"
            :parentStateName="$_getFieldAttr(fieldKey,'parentStateName')"
            :requiredFieldState="$_getParentState(fieldKey,modedFields)"
            :originValue="$_getOriginValue(modelData,fieldKey)"
            :originData="updateData"
            :originDataEX="modelData"
            :defaultValue="$_getDefaultValue(fieldKey,modedFields,'defaultValue')"
            :customParentData="customParentData"
            :displayCheck="$_getFieldAttr(fieldKey,'displayCheck')"
            :clearable="$_getFieldAttr(fieldKey,'clearable')"
            :autocomplete="$_getFieldAttr(fieldKey,'autocomplete')"
            :value="updateData[fieldKey]"
            @input="$_onInput(fieldKey,$event)"
            :rulesErrorMessage="$_getFieldAttr(fieldKey, 'rulesErrorMessage')"
            :getRules="$_getFieldAttr(fieldKey, 'getRules')"
            :des="$_getFieldAttr(fieldKey, 'des')"
            :layersSetting="$_getFieldAttr(fieldKey, 'layersSetting')"
            :multiple="$_getFieldAttr(fieldKey, 'multiple')"
            :getUrl="$_getFieldAttr(fieldKey, 'getUrl')"
            :format="$_getFieldAttr(fieldKey,'format')"
            :disabledDate="$_getFieldAttr(fieldKey,'disabledDate')"
            :disabledTime="$_getFieldAttr(fieldKey,'disabledTime')"
          ></WsState>
        </div>
        <div v-if="floor.link">
          <span class="caption">{{floor.link.hint}} </span>
          <WsBtn
            @click="$_onChangePageOpen(floor.link)"
            outlined
          >
            {{floor.link.btnName}}
          </WsBtn>

        </div>
      </div>
    </WsCard>
    <WsDataExpandList
      v-if="type=='expandList'"
      ref="wsDataExpandList"
      :modelName="modelName"
      :label="label"
      :parentModelName="parentModelName"
      :parentState="parentState"
      :locale="locale"
      :fields="fields"
      :titleKey="titleKey"
      :searchMode="searchMode"
      :batchMode="batchMode"
      :fieldsRead="fieldsRead"
      :modeVersions="modeVersions"
      :modelData="modelData"
      :orderBy="orderBy"
      :orderWay="orderWay"
      :hideOnNull="hideOnNull"
      :createVersion="createVersion"
      :itemVersionCreatable="itemVersionCreatable"
      :itemVersionLinkCreatable="itemVersionLinkCreatable"
      :itemVersionReadable="itemVersionReadable"
      :itemDeletable="itemDeletable"
      :itemEditable="itemEditable"
      :itemLinkCheckable="itemLinkCheckable"
      :params="params"
      :postData="postData"
      :isGetAll="isGetAll"
      :modelVersionName="modelVersionName"
      :hasSequence="hasSequence"
      :hasChapters="hasChapters"
      :customParentData="_customParentData"
      :expandDisable="expandDisable"
      :groupSaving="groupSaving"
      :articleSaving="articleSaving"
      :getUrl="getUrl"
      :disableSaveBtn="disableExpandListItemSaveBtn"
      :customSubmitModelDatasAction="customSubmitModelDatasAction"
      @created="$_onCreated($event)"
      @groupSave="$emit('groupSave',$event)"
      @fetch="$emit('fetch', $event)"
      @item-changed="$emit('item-changed', $event)"
    ></WsDataExpandList>
    <!-- <WsAlertDialog
      ref="createDialog"
      :label="label"
      :fields="_createFields"
      :modelName="'123'"
      :errorMessages="createErrorMessages"
      @create-submit="$_onCreateSubmit($event)"
    /> -->
    <WsAlertDialog
      ref="changePageDialog"
      :title="createErrorMessages"
      description="前往頁面後，將捨棄目前新增所填寫的資料。"
      btnText="確認前往"
      @submit="$_onChangePageSubmit($event)"
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    createErrorMessages: "",
  }),
  props: {
    modelData: {
      type: Object,
      default: null,
    },
    updateData: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    remark: {
      type: String,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    fieldsRead: {
      type: Array,
      default: null,
    },
    modedFields: {
      type: Object,
      required: true,
    },
    field: {
      type: String,
      default: null,
    },
    fields: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: "infoCard",
    },
    floors: {
      type: Array,
      default() {
        return [];
      },
    },
    parentModelName: {
      type: String,
      default: null,
    },
    modelName: String,
    modeParent: {
      type: Boolean,
      default: false,
    },
    customButtons: {
      type: Array,
      default: null,
    },
    customParentData: {
      type: [Object, Function],
    },
    itemVersionCreatable: {
      type: Boolean,
    },
    itemVersionLinkCreatable: {
      type: Boolean,
    },
    itemVersionReadable: {
      type: Boolean,
    },
    itemEditable: {
      type: Boolean,
    },
    itemDeletable: {
      type: Boolean,
    },
    itemLinkCheckable: {
      type: Boolean,
    },
    parentState: {
      type: [Number, String],
      default: null,
    },
    expandDisable: {
      type: Boolean,
      default: false,
    },
    searchMode: {
      type: Boolean,
      default: false,
    },
    batchMode: {
      type: Boolean,
      default: false,
    },
    hasChapters: {
      type: Boolean,
      default: false,
    },
    hasSequence: {
      type: Boolean,
      default: false,
    },
    modelVersionName: {
      type: String,
      default: "",
    },
    isGetAll: {
      type: Boolean,
      default: false,
    },
    postData: {
      type: Object,
    },
    modeVersions: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
    },
    orderBy: {
      type: String,
      default: "sequence",
    },
    orderWay: {
      type: String,
      default: "asc",
    },
    hideOnNull: {
      type: Boolean,
      default: false,
    },
    createVersion: {
      type: Boolean,
      default: false,
    },
    titleKey: {
      type: String,
      default: null,
    },
    groupSaving: {
      type: Boolean,
    },
    articleSaving: {
      type: Boolean,
      default: false,
    },
    getUrl: {
      type: Function,
    },
    disableExpandListItemSaveBtn: {
      type: Boolean,
      default: false
    },
    customSubmitModelDatasAction: {
      type: Function,
    }
  },
  methods: {
    $_onInput(fieldKey, $event) {
      if (this.modedFields[fieldKey].type == "act-picker" || this.modedFields[fieldKey].type == "multi-layer") {
        this.$emit("input", {
          ...this.updateData,
          ...$event,
        });
      } else {
        this.$emit("input", {
          ...this.updateData,
          [fieldKey]: $event,
        });
      }
    },
    $_getOriginValue(modelData, fieldKey) {
      if (!modelData) {
        return null;
      } else {
        return modelData[fieldKey];
      }
    },
    $_getConditions(fieldKey) {
      const _conditions = [];
      const conditionKeys = this.$_getFieldAttr(fieldKey, "conditionKeys");
      if (!conditionKeys) {
        return [];
      }
      conditionKeys.forEach((conditionKey) => {
        let _value = "";
        if (this.updateData[conditionKey.fieldName]) {
          _value = this.updateData[conditionKey.fieldName];
        } else if (
          this.customParentData &&
          this.customParentData[conditionKey.fieldName]
        ) {
          _value = this.customParentData[conditionKey.fieldName];
        } else if (this.modelData && this.modelData[conditionKey.fieldName]) {
          _value = this.modelData[conditionKey.fieldName].id;
        } else {
          _value = null
        }
        _conditions.push({
          key: conditionKey.conditionName,
          value: _value,
          type: conditionKey.type,
        });
      });
      return _conditions;
    },
    $_getFieldAttr(fieldKey, keyName) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, this.modedFields);
      return field[keyName];
    },
    $_getParentState(fieldKey, modedFields) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, modedFields);
      if (modedFields[fieldKey].requiredField) {
        if (this.customParentData) {
          if (this.customParentData[modedFields[fieldKey].requiredField]) {
            return this.customParentData[modedFields[fieldKey].requiredField];
          }
        }
      }
      if (field.getParentStateKey) {
        return this.updateData[field.getParentStateKey];
      } else if (field.parentKey) {
        return this.updateData[field.parentKey];
      } else if (field.requiredField) {
        return this.updateData[field.requiredField];
      } else {
        return null;
      }
    },
    $_onChangePageOpen(link) {
      this.createErrorMessages = link.alertTitle;
      this.$refs.changePageDialog.open(link.path);
    },
    $_onChangePageSubmit(val) {
      this.$router.push(val);
    },
    $_getDefaultValue(fieldKey, modedFields, keyName) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, modedFields);
      if (field[keyName] !== undefined && field[keyName] !== null) {
        return field[keyName];
      } else {
        return null;
      }
    },
    async $_onPropsData() {
      await this.$refs.wsDataExpandList.$_groupSaveSubmit();
    },
  },
  computed: {
    _localeField() {
      let _localeField = null;
      for (let fieldKey in this.modedFields) {
        const field = this.modedFields[fieldKey];
        if (field.type == "locales") {
          _localeField = field;
        }
      }
      return _localeField;
    },
    _localeFieldKey() {
      let _localeFieldKey = null;
      for (let fieldKey in this.modedFields) {
        const field = this.modedFields[fieldKey];
        if (field.type === "locales") {
          _localeFieldKey = fieldKey;
        }
      }
      return _localeFieldKey;
    },
    _customParentData() {
      if (this.customParentData && typeof this.customParentData === 'function') {
        return this.customParentData(this.modelData);
      } else {
        return null;
      }
    },
  },
};
</script>

<style>
</style>